import type { ColumnDef } from '@tanstack/react-table';
import {
  createSerialColumn,
  FooterAmount,
  getAreaColumn,
  MemberNameCell,
  toHeaderHintMeta,
} from '@/components/common/DataTable';
import { formatNumber } from '@/utils/number';
import type {
  DerDashboardColumn,
  DerDashboardRow,
  DerDashboardTotals,
} from '../types/dashboard.types';
import { getAmNameColumn } from './AmNameColumn';

export function getDerDashboardColumns(
  expenseTypes: DerDashboardColumn[],
  searchText: string | undefined,
  totals: DerDashboardTotals | undefined,
): ColumnDef<DerDashboardRow, unknown>[] {
  return [
    createSerialColumn<DerDashboardRow>(),
    {
      accessorKey: 'name',
      header: 'ZM Name',
      cell: ({ row }) => <MemberNameCell member={row.original} searchText={searchText} />,
      footer: 'Grand Total',
    },
    getAmNameColumn<DerDashboardRow>(),
    getAreaColumn<DerDashboardRow>(),
    ...expenseTypes.map((expenseType) => ({
      id: `expense-${expenseType.id}`,
      header: expenseType.code ?? expenseType.name,
      ...(expenseType.code ? { meta: toHeaderHintMeta(expenseType.name) } : {}),
      cell: ({ row }: { row: { original: DerDashboardRow } }) => (
        <span className="tabular-nums">
          {formatNumber(row.original.amounts[String(expenseType.id)] ?? 0)}
        </span>
      ),
      footer: () => (
        <FooterAmount
          amount={totals ? (totals.byExpenseType[String(expenseType.id)] ?? 0) : undefined}
        />
      ),
    })),
    {
      accessorKey: 'total',
      header: 'Total',
      cell: ({ row }) => (
        <span className="font-medium tabular-nums">{formatNumber(row.original.total)}</span>
      ),
      footer: () => <FooterAmount amount={totals?.total} />,
    },
  ];
}
